uniform vec3 uBaseColor;
uniform vec3 uFresnelColor;
uniform float uFresnelPower;
uniform float opacity;
varying vec3 vPositionW;
varying vec3 vNormalW;
varying vec2 vUv;
uniform float uTime;
varying float vCarrierDistance;
uniform vec3 uCarrierPosition;

void main() {
  vec3 viewDirectionW = normalize(cameraPosition - vPositionW);
  float fresnelTerm = dot(viewDirectionW, vNormalW * -1.);
  fresnelTerm = clamp(1.0 - fresnelTerm, 0., 1.);
  fresnelTerm = pow(fresnelTerm, uFresnelPower);

  vec3 color1 = mix(uBaseColor, uFresnelColor, fresnelTerm);
  // float p = gln_simplex(vec2(vUv.x * 10000., vUv.y * 4.));
  float fieldScale = .25;
  float p = gln_simplex(vec2(vUv.x * 8000. * fieldScale, vUv.y * 4. * fieldScale + uTime * .5));
  float sin = sin(uTime * 2.);
  sin = gln_normalize(sin);
  sin = sin * 0.1 + 0.4;
  p = gln_normalize(p);
  // p += 1.;
  // p = p / 2.;
  p = smoothstep(0.85, .95, p);
  p = p * sin;
  float dist = min(1., max(1. - vCarrierDistance * 5., 0.));
  dist = pow(dist, 2.);

  gl_FragColor = vec4(mix(color1 * 2., uBaseColor * 3., p), opacity * dist * 1.);
  // gl_FragColor = vec4(vec3(dist), 1.);
  // gl_FragColor = vec4(viewDirectionW, 1.);
  // gl_FragColor = vec4(vec3(p, 0., 0.), 1.);
}